module.exports = __webpack_public_path__ + "img/mission.0ff1eeec.jpg";